import React, { useCallback, useContext, useEffect, useState } from 'react'
import { DContext } from '../../../context/Datacontext';

import { Pagination } from '../../../utils/Pagination';

import { fetchCourseStatus } from '../../../services/coures/fetchCourseStatus';
import { CourseList } from './CourseList';
import { SmartFilterBar } from '../../../components/common/SmartFilterBar';


export const Courses = () => {
  const { BeURL } = useContext(DContext);

  const [activeTab, setActiveTab] = useState("all");
  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);

  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(() =>
    Number(localStorage.getItem("coursePage")) || 1
  );
  const [limit, setLimit] = useState(() =>
    Number(localStorage.getItem("courseLimit")) || 10
  );
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);

  // save pagination state
  useEffect(() => {
    localStorage.setItem("coursePage", page);
    localStorage.setItem("courseLimit", limit);
  }, [page, limit]);

  useEffect(() => {
    loadData();
  }, [activeTab, page, limit,filters]);

  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetchCourseStatus({
        BeURL,
        type: activeTab,
        page,
        limit,
        ...filters
      });

      if (res?.success) {
        setCourses(res.courses || []);
        setTotalPages(res.totalPages || 1);
        setTotal(res.total || 0);
      }

    } catch (err) {
      console.log("Error in fetch course status",err);
    } finally {
      setLoading(false);
    }

  }, [BeURL, activeTab, page, limit, filters]);

  useEffect(() => {

    loadData();

  }, [loadData]);

  return (
    <div className="p-6 space-y-6" >
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">Courses</h2>
        <span className="bg-primary-100 text-primary-700 text-xs px-3 py-1 rounded-full">
          Total: {total}
        </span>
      </div>

      <SmartFilterBar
        BeURL={BeURL}
        onChange={(f) => {
          setFilters(f);
          setPage(1);
        }}
      />


      <div className="flex gap-6 border-b">
        {["all", "pending", "approved", "rejected", "draft"].map(tab => (

          <button
            key={tab}
            onClick={() => {
              setActiveTab(tab);
              setPage(1);
            }}
            className={`pb-2 border-b-2 capitalize ${activeTab === tab
              ? "border-primary-600 text-primary-600"
              : "border-transparent"}`}
          >
            {tab}
          </button>

        ))}

      </div>

  
        <CourseList courses={courses} />
   


      {/* PAGINATION */}

      <Pagination
        page={page}
        totalPages={totalPages}
        limit={limit}
        totalUsers={total}
        setPage={setPage}
        // setLimit={setLimit}
        setLimit={(newLimit) => {

          const firstIndex = (page - 1) * limit;
          const newPage = Math.floor(firstIndex / newLimit) + 1;

          setLimit(newLimit);
          setPage(newPage);
        }}
      />
    </div>
  )
}
